// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609211604/js/" + chunkId + "." + {"44":"27decb2c","225":"dbde5cb5","481":"8e08205f","486":"cc87efb8","770":"0eef8d05"}[chunkId] + ".0.5158462660062949.chunk.js";
};